import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkforceService } from 'api/services';
import { EmployeePayload } from 'api/services/workforce/workforce-service.types';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

type EmployeeMutationOptions = UseMutationOptions<string, unknown, EmployeePayload>;

export const useCreateEmployee = (options?: EmployeeMutationOptions) => {
  const mutationFn = async (employee: EmployeePayload) =>
    await sharedWorkforceService.createEmployee(employee);

  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  const mutationOptions: EmployeeMutationOptions = {
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.workforce());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  };

  return useMutation(mutationFn, mutationOptions);
};
